<template>
  <div>
    <div class="header">
      <h1>
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <i class="fas fa-arrow-left" id="arrow" @click="back"></i>
        </transition>
        Detalji upravnika
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <!--bedz u desnom uglu se prikazuje samo kada je otvorena kartica-->
          <i class=" fas fa-user badge--mod"></i>
        </transition>
      </h1>
    </div>
    <div class="body-wrapper">
      <modal-confirm-action
        v-if="showDeleteDocumentModal"
        @close="showDeleteDocumentModal = false"
        @confirm="deleteDocument"
        :isLoading="deleteLoading"
        title="Brisanje dokumenta"
      >
        <div>Da li ste sigurni da želite da obrišete dokument:</div>
        <div>{{ documentToDelete.file_name }}</div>
      </modal-confirm-action>
      <div class="left-column">
        <div class="box">
          <div class="title-wrapper flex">
            <b class="title">Informacije</b>
          </div>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
          <div class="info-box">
            <div class="user-image">
              <img
                :src="baseObjectStorageUrl + userDetails.user.media.link"
                alt=""
              />
            </div>
            <div class="left-column" v-if="!loading">
              <div class="div-description single-info">
                <small class="label">Prezime i ime</small>
                <h4 class="value">{{ userDetails.user.fullName }}</h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Email</small>
                <h4 class="value">
                  {{ userDetails.user.email }}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="box invoices">
          <div class="title-wrapper">
            <b class="title">Dokumenta</b>
            <a class="btn" @click="opetAddDocument()">
              <i class="fas fa-plus"></i>
            </a>
          </div>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
          <div class="table" v-if="!loading">
            <!-- TODO Fill table when media added -->
            <div v-if="userDetails.documents.length == 0">
              Ne postoje dokumenta
            </div>
            <div ref="rows" class="rows">
              <div
                class="row"
                v-for="row in userDetails.documents"
                :key="row.id"
              >
                <div class="parent">
                  <a
                    class="column document-name"
                    target="_blank"
                    style="flex: 6"
                    :href="baseObjectStorageUrl + row.link"
                  >
                    {{ row.file_name }}
                  </a>
                  <div class="column actions" style="flex: 1">
                    <a class="btn" @click="openDeleteDocument(row)">
                      <i class="fas fa-minus"></i>
                    </a>
                    <a
                      class="btn"
                      target="_blank"
                      :href="baseObjectStorageUrl + row.link"
                    >
                      <i class="fas fa-file-download"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-column">
        <div class="box transactions">
          <div class="title-wrapper">
            <b class="title">Zajednice</b>
            <a class="btn" @click="openAddCommunity">
              <i class="fas fa-plus"></i>
            </a>
          </div>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
          <div class="table" v-if="!loading">
            <div v-if="userDetails.communities.length == 0">
              Ne postoje zajednice
            </div>
            <div ref="rows" class="rows">
              <div
                class="row"
                v-for="row in userDetails.communities"
                :key="row.id"
              >
                <div class="parent">
                  <div class="column">
                    {{ row.address }} {{ row.streetNumber }}, {{ row.city }}
                  </div>
                  <div class="column actions contractor-details">
                    <a class="btn" @click="openRemoveCommunity(row)">
                      <i class="fas fa-minus"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import axios from '@/axios/axios.js';
import { addSeparatorMixin } from '@/mixins/mixins.js';
import modalConfirmAction from '@/components/modal/ModalConfirmAction.vue';
import { UserRoles } from '@/util/UtilService.js';

export default {
  name: 'CommunityFinancesMember',
  mixins: [addSeparatorMixin],
  components: {
    modalConfirmAction
  },
  data() {
    return {
      baseObjectStorageUrl: process.env.VUE_APP_OBJECT_STORAGE_URL,
      showDeleteDocumentModal: false,
      documentToDelete: null,
      deleteLoading: false,
      userDetails: null,
      userDocuments: []
    };
  },
  computed: {
    ...mapState(['loading'])
  },
  async created() {
    // only super manager can access this page
    if (
      this.$store.getters.getUser.roles.indexOf(UserRoles.SUPER_MANAGER) == -1
    ) {
      this.$router.push('/notFound');
    }
    this.cardOpened();
    this.setTableBadge('fas fa-tools');
    try {
      this.loadingStarted();
      const userDetails = await this.getManagerUserDetails(
        this.$route.params.userId
      );
      const userDocuments = await this.getUserDocuments();
      userDetails.documents = userDocuments;
      this.setManager(userDetails);
      this.userDetails = this.$store.state.modal.manager;
      // get documents
      this.loadingFinished();
    } catch (error) {
      this.loadingFinished();
      if (error.response && error.response.status == 404) {
        this.$router.push('/notFound');
      } else {
        console.log(error);
        this.showFailModal();
        throw error;
      }
    }
  },
  destroyed() {
    this.setTableBadge('');
  },
  methods: {
    ...mapMutations(['cardOpened']),
    ...mapMutations('table', [
      'setTableData',
      'setTableBadge',
      'setInfrastructure'
    ]),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapActions('table', ['getManagerUserDetails']),
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', [
      'showModal',
      'setManager',
      'setManagerCommunity'
    ]),

    back() {
      this.$router.back();
    },
    openAddCommunity() {
      this.setManager(this.userDetails);
      this.showModal('ModalContentAddManagerCommunity');
    },
    opetAddDocument() {
      this.setManager(this.userDetails);
      this.showModal('ModalContentAddUserDocument');
    },
    openRemoveCommunity(community) {
      this.setManagerCommunity(community);
      this.showModal('ModalContentRemoveManagerCommunity');
    },
    toggleItems(contact) {
      contact.isExpanded = !contact.isExpanded;
      // FIXME Find a way to detect change without this
      this.infrastructure.contractors = [...this.infrastructure.contractors];
    },
    async getUserDocuments() {
      try {
        const result = await axios.get(
          `user/${this.$route.params.userId}/user-document`
        );
        return result.data.data;
      } catch (error) {
        throw error;
      }
    },
    openDeleteDocument(document) {
      this.documentToDelete = document;
      this.showDeleteDocumentModal = true;
    },
    async deleteDocument() {
      try {
        this.deleteLoading = true;
        const data = {
          mediaId: this.documentToDelete.id
        };
        await axios.delete(`user/${this.$route.params.userId}/user-document`, {
          data: data
        });
        const userDocuments = await this.getUserDocuments();
        this.userDetails.documents = userDocuments;
        this.setManager(this.userDetails);
        this.userDetails = this.$store.state.modal.manager;
        this.deleteLoading = false;
        this.showSuccessModal();
        this.showDeleteDocumentModal = false;
      } catch (error) {
        console.log(error);
        this.deleteLoading = false;
        this.showFailModal();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.badge--mod {
  position: absolute;
  right: 0;
  left: unset;
  border-radius: 50%;
  padding: 5px;
  margin-right: 10px;
}
.header {
  padding: 10px 10px 0 10px;
}
.header-contractor {
  margin-bottom: 40px;
  .badge--mod {
    position: absolute;
    right: 0;
    left: unset;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
  }
}
.contractor-details {
  margin-left: auto;
}
.invoice-date {
  background: none !important;
  font-size: 0.8rem;
  font-weight: 800;
}
.box {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0), 0 2px 15px rgba(0, 0, 0, 0.24);
  margin-bottom: 1rem;
  padding: 16px;
  position: relative;
}

.title-wrapper {
  margin-bottom: 12px;
  .title {
    font-size: 1.2rem;
    color: black;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--primary-color);
  }

  .btn {
    color: var(--primary-color);
    background: #e6e6e6;
    padding: 2px 5px;
    font-size: 0.9rem;
    float: right;
    margin-right: 14px;
    &:hover {
      background: rgb(210, 210, 210);
    }
  }

  .icons-wrapper {
    display: inline-block;
    margin-left: auto;
    font-size: 1.4rem;
    i {
      padding: 7px 5px;
    }
    .box-icon {
      // position: absolute;
      // top: 0.8rem;
      // right: 0.8rem;
      color: var(--primary-color);
    }
    .invite-members-icon {
      background-color: #e6e6e6;
      padding: 7px 5px;
      border-radius: 5px;
      transition: background-color 0.2s;
    }

    .invite-members-icon:hover {
      background-color: #d2d2d2;
      cursor: pointer;
    }

    .icon-notice {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-notice:hover {
      color: #dc3546;
      cursor: pointer;
    }

    .icon-default {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-default:hover {
      color: var(--primary-color);
      cursor: pointer;
    }
  }
}

.body-wrapper {
  display: flex;
  height: 100%;
  .left-column {
    flex: 3;
    height: 100%;
    .info-box {
      width: 100%;
      // border: 1px solid var(--primary-color);
      border-radius: 4px;
      display: flex;
      // align-items: flex-end;
      // padding: 8px 8px 8px 0;
      padding: 0;
      .user-image {
        // flex: 3;
        padding: 2px 16px 8px 4px;
        display: flex;
        align-items: center;
        img {
          height: 100px;
          width: 100px;
          -o-object-fit: cover;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .left-column {
        flex: 5;
        display: flex;
        flex-direction: column;
      }
      .right-column {
        flex: 3;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
      }

      .single-info {
        // margin-left: 8px;
        // border: 1px solid black;
        display: flex;
        flex-direction: column;
        padding-top: 2px;
        margin-bottom: 2px;
        &.balance {
          &.positive {
            .value {
              color: var(--primary-color);
            }
          }
          &.negative {
            .value {
              color: rgba(220, 53, 70, 1);
            }
          }
          small {
            text-align: right;
          }
        }
      }

      h2,
      h4 {
        padding: 0;
        margin: 0;
        word-break: break-word;
      }
    }
    .invoices {
      width: 100%;
      height: calc(100% - 220px);
    }
  }
  .right-column {
    flex: 4;
    margin-left: 1rem;
  }
  .table {
    margin-bottom: 0;
    font-size: 0.9rem;
    position: relative;
    z-index: 0;
    height: calc(100% - 30px);

    .right-padding {
      .column:last-of-type {
        padding-right: 0.7rem;
      }
    }

    .rows {
      max-height: calc(100% - 30px);
      overflow-y: auto;

      .row {
        width: 100% !important;
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .parent {
          padding: 3px 0;
          width: 100%;
          display: flex;
          .more {
            margin-right: 8px;
          }
        }

        .more-btn {
          cursor: pointer;
          i {
            transform: rotate(0);
            transition: transform 0.2s;
          }
        }

        .items {
          display: none;
          width: 100%;
          flex-direction: column;
          padding-left: 8px;
          .row {
            display: flex;
            flex-direction: row;
            background: rgb(240, 240, 240);
            padding-left: 6px;
            border-radius: 4px;
            margin-bottom: 2px;
          }
          .row-desc {
            font-weight: bold;
          }
          .column {
            word-break: break-word;
          }
        }

        &.expanded-content {
          .items {
            display: flex;
          }
          .more-btn {
            i {
              transform: rotate(90deg);
            }
          }
        }

        .column {
          text-align: left;
          display: flex;
          align-items: center;
        }
      }
    }
    .labels {
      border-bottom: 1px solid gray;
      .column {
        font-weight: 600;
      }
    }
    .actions {
      display: flex;
      justify-content: flex-end;
      padding-right: 10px;
      .btn {
        background: rgb(230, 230, 230);
        margin: 0 4px;
        height: 24px;
        width: 24px;
        padding: 0 0 2px 2px;
        position: relative;
        &:hover {
          background: rgb(210, 210, 210);
        }
        i {
          font-size: 0.9rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: var(--primary-color);
        }
      }
    }
  }
}
.email-field {
  margin: 3px 0;
}
.email-subject {
  margin-bottom: 5px;
}

.flex {
  display: flex;
}

.upload-area {
  margin-top: 5px;
  padding: 5px 0;

  .no-files {
    padding: 0 5px;
  }
  .uploaded {
    background-color: rgb(241, 241, 241);
    border-radius: 4px;
  }
  .file {
    border-bottom: solid 1px lightgray;
    font-size: 15px;
    width: 100%;
    display: inline-flex;
    align-items: center;
    padding: 0 5px;
    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding-right: 8px;
      margin-bottom: 2px;
    }

    .del--mod {
      margin-left: auto;

      cursor: pointer;
      color: red;
    }
  }
}
</style>
